"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _styles = require("@material-ui/core/styles");

var _solarReact = require("@solar/solar-react");

var _colors = require("@material-ui/core/colors");

var _excluded = ["align", "className", "status", "prevStatus", "statusLabel", "text", "_id"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: _objectSpread(_objectSpread({}, theme.typography.subheading), {}, {
      display: 'block',
      padding: "".concat(theme.increments.typography, "px ").concat(theme.increments.typography * 3, "px"),
      backgroundColor: theme.palette.background["default"],
      whiteSpace: 'pre-wrap',
      marginBottom: 4
    }),
    margin: {
      marginBottom: 4
    },
    colorInherit: {
      color: 'inherit'
    },
    colorPrimary: {
      backgroundColor: theme.palette.primary[500],
      // color: theme.palette.getContrastText(theme.palette.primary[500]),
      color: 'white'
    },
    colorSecondary: {
      backgroundColor: theme.palette.secondary[100],
      color: theme.palette.getContrastText(theme.palette.secondary[100])
    },
    colorblue: {
      backgroundColor: _colors.blueGrey[100],
      color: theme.palette.getContrastText(_colors.blueGrey[100])
    },
    colorlightGreen: {
      backgroundColor: _colors.lightGreen[100],
      color: theme.palette.getContrastText(_colors.lightGreen[100])
    },
    colorgreen: {
      backgroundColor: _colors.green[100],
      color: theme.palette.getContrastText(_colors.green[100])
    },
    colororange: {
      backgroundColor: _colors.orange[100],
      color: theme.palette.getContrastText(_colors.orange[100])
    }
  };
});

var ChatStatus = function ChatStatus(_ref) {
  var align = _ref.align,
      className = _ref.className,
      status = _ref.status,
      prevStatus = _ref.prevStatus,
      statusLabel = _ref.statusLabel,
      text = _ref.text,
      _id = _ref._id,
      other = _objectWithoutProperties(_ref, _excluded);

  var classes = useStyles();

  var color = function color() {
    if (['approved', 'reviewed', 'validated', 'published_provisional'].includes(status)) {
      return 'lightGreen';
    }

    if (status === 'rejected') {
      return 'orange';
    }

    if (status === 'published') {
      return 'green';
    }

    return 'blue';
  };

  return /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, /*#__PURE__*/_react["default"].createElement(_solarReact.Rounded, _extends({
    key: _id,
    align: align,
    className: (0, _classnames["default"])(classes.root, classes.marginroot, className, classes["color".concat(color())])
  }, other), statusLabel), text && /*#__PURE__*/_react["default"].createElement(_solarReact.ChatText, {
    key: _id,
    color: align === 'right' ? 'primary' : null,
    align: align,
    component: _solarReact.Rounded,
    className: (0, _classnames["default"])(classes.margin, align === 'right' && classes.colorPrimary)
  }, text));
};

ChatStatus.propTypes = {
  align: _propTypes["default"].string,
  classes: _propTypes["default"].object.isRequired,
  className: _propTypes["default"].string
};
ChatStatus.defaultProps = {
  className: ''
}; // prettier-ignore

var _default = ChatStatus;
exports["default"] = _default;